import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../pages/auth/authSlice';
import notifyReducer from '../pages/auth/notify';
import routeReducer from '../pages/configuration/routeSlice';
import switchReducer from '../pages/configuration/customerSwitchUserSlice';
import jobSchedulerReducer from '../pages/job-scheduler/jobSchedulerSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    route: routeReducer,
    notify: notifyReducer,
    switch: switchReducer,
    jobScheduler: jobSchedulerReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
